import type { TFunction } from 'i18next';

import { MfaPasskeySetupDialogs } from './mfa-passkey-setup';

export function MfaPasskeySetupDialog({
  addAnother,
  isMobile,
  onCancel,
  onConfirmPasskeyRegistration,
  onFinishPrimaryReplace,
  onManagePasskey,
  onBackToMethods,
  optionsJson,
  t,
}: {
  addAnother: boolean;
  isMobile: boolean;
  onCancel: () => void;
  onConfirmPasskeyRegistration: (responseJson: string) => Promise<boolean | 'backup'>;
  onFinishPrimaryReplace: () => Promise<boolean>;
  onManagePasskey: () => void;
  onBackToMethods: () => void;
  optionsJson: string;
  t: TFunction<'common'>;
}) {
  return (
    <MfaPasskeySetupDialogs
      isMobile={isMobile}
      onBackToMethods={addAnother ? onManagePasskey : onBackToMethods}
      onCancel={addAnother ? onManagePasskey : onCancel}
      onCreated={async () => {
        if (onFinishPrimaryReplace && (await onFinishPrimaryReplace())) {
          return;
        }
        if (addAnother) {
          onManagePasskey();
          return;
        }
        onCancel();
      }}
      onRegister={async responseJson => await onConfirmPasskeyRegistration(responseJson)}
      optionsJson={optionsJson}
      t={t}
    />
  );
}
